import { render, staticRenderFns } from "./ClientBottom.vue?vue&type=template&id=30e51908&scoped=true&"
import script from "./ClientBottom.vue?vue&type=script&lang=js&"
export * from "./ClientBottom.vue?vue&type=script&lang=js&"
import style0 from "./ClientBottom.vue?vue&type=style&index=0&id=30e51908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e51908",
  null
  
)

export default component.exports